<template>
  <div>
    <!-- Toasts -->
    <div
      aria-live="assertive"
      class="pointer-events-none fixed inset-0 z-50 flex items-end px-4 py-4"
    >
      <div class="flex w-full flex-col items-center space-y-2">
        <TransitionGroup
          enter-active-class="transform ease-out duration-300 transition"
          enter-from-class="translate-y-2 opacity-0"
          enter-to-class="translate-y-0 opacity-100"
          leave-active-class="transform transition ease-in duration-100"
          leave-from-class="translate-y-0 opacity-100"
          leave-to-class="translate-y-4 opacity-0"
        >
          <UpmToast
            v-for="toast in toasts"
            :toast="toast"
            :key="`toast-${toast._id}`"
            >{{ toast._id }}</UpmToast
          >
        </TransitionGroup>
      </div>
    </div>

    <!-- Notifications -->
    <div
      aria-live="assertive"
      class="pointer-events-none fixed inset-0 z-50 flex items-start px-4 py-4 sm:p-6"
    >
      <div class="flex w-full flex-col items-center space-y-2 sm:items-end">
        <TransitionGroup
          enter-active-class="transform ease-out duration-300 transition"
          enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
          enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
          leave-active-class="transform transition ease-in duration-200"
          leave-from-class="translate-y-0 opacity-100"
          leave-to-class="-translate-y-4 opacity-0"
        >
          <UpmNotification
            v-for="notification in notifications"
            :notification="notification"
            :key="`toast-${notification._id}`"
            >{{ notification._id }}</UpmNotification
          >
        </TransitionGroup>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from "pinia";
import { useWidgetStore } from "@src/stores/WidgetStore";
import UpmNotification from "@src/components/UpmNotification.vue";
import UpmToast from "@src/components/UpmToast.vue";

const { notifications, toasts } = storeToRefs(useWidgetStore());
</script>
